const isDev = process.env.VUE_APP_MODE !== 'production'
const isTest = process.env.VUE_APP_NETWORK !== 'public'
// const isDeploy = process.env.VUE_APP_DEPLOY === 'true'

export default {
  authUrl: isDev ? 'https://localhost:4000/dev' : isTest ? 'https://api-testnet.stellarauth.com' : 'https://api.stellarauth.com',
  horizonUrl: isTest ? 'https://horizon-testnet.stellar.org' : 'https://horizon.stellar.org',
  network: isTest ? 'TESTNET' : 'PUBLIC',
  scanBotLicenseKey: 'AeJrNymOY6wpA/i77kaqrXNX4TL4xxR5EdbKc+7qm6quMKCPshmksusiqdeSAEVsmk3IhRPjcLlYzBS2EMR48Nt438djRc/0vrKcvlcapg+mCHvAMQ9uF1ICoGWFzyhOHDQ7iMKBkshKu82fZKfIJ8l74waUtAnxd1XsF59QErBRHnnoqBKno9sAfeiSDewZ4+9v4yMnRJ8mIl4wNpDkDe9x0RBibpQmIsJzRNcwEoh6v39oOzC1TtNo5yfuKLS7d5Ti1W38sLDd4QhVoZAS5Raj/kssyI9Y/ILtl9wZub5Yw6kt074fB0rQmL/7ITKVbRxh1RSDqaZQJMXYX1UABw==\nU2NhbmJvdFNESwpjb20uc3RlbGxhcmF1dGgKMTU2NDc5MDM5OQo1OTAKMw==\n',
  pusherKey: '5d9d373e445fa0c34f5a',
  isDev,
  isTest,
  // isDeploy
}